import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserTeams, updateTeam } from '../../firebase/api/teams';
import { getAllUsers } from '../../firebase/api/users';
import { getUserUid } from '../../static/localStorage';

export const fetchUserTeams = createAsyncThunk('fetchUserTeams', async (_, { rejectWithValue }) => {
    try {
        const userId = getUserUid();
        let response = [];
        await getUserTeams(userId).then(items => {
            response = items.map(item => ({
                name: item.teamName,
                uid: item.teamId,
                invitedUsers: item.invitedUsers,
            }));
        });
        return {
            data: response,
        };
    } catch (e) {
        return rejectWithValue(e.message);
    }
});

export const fetchUsers = createAsyncThunk('fetchUsers', async (_, { rejectWithValue }) => {
    try {
        let response = [];
        const userId = getUserUid();
        await getAllUsers().then(items => {
            response = items
                .filter(item => item.uid !== userId)
                .map(item => ({
                    name: item.firstName
                        ? `${item.firstName}${item.lastName.length ? ' ' + item.lastName : ''}`
                        : `${item.email}`,
                    firstName: item?.firstName || '',
                    lastName: item?.lastName || '',
                    email: item.email,
                    position: item.position || '',
                    website: item.website || '',
                    uid: item.uid,
                }));
        });
        return {
            data: response,
        };
    } catch (e) {
        return rejectWithValue(e.message);
    }
});

export const addUserToTeams = createAsyncThunk(
    'addUserToTeams',
    async ({ teams, userEmail, callback }, { rejectWithValue }) => {
        try {
            for (let team of teams) {
                const dto = {
                    teamId: team.uid,
                    invitedUsers: [...team.invitedUsers, userEmail],
                };
                await updateTeam(dto);
            }
            await callback();
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
